import { BlogLayout } from './Blog.layout';
import { DefaultLayout } from './Default.layout';
import { ErrorLayout } from './Error.layout';

export const Layout = {
	Blog: BlogLayout,
	Default: DefaultLayout,
	Error: ErrorLayout,
};
